import { useState } from 'react';
import { Container } from 'react-bootstrap';
import DeleteIconSecondary from '../../assets/DeleteIconSecondary.svg';
import { incompleteBasicInfoFields } from '../../utils/data';
import { updateBlockFields } from '../../utils/helpers';
import BorderlessButton from '../Buttons/BorderlessButton';
import InfoBlock from '../BusinessInfo/InfoBlock';
import DeleteOnboardingModal from '../DeleteOnboardingModal/DeleteOnboardingModal';

export interface IncompleteOnboardingBusinessData {
  id?: number | string;
  rut?: string | number | null;
  fantasyName?: string;
  socialReason?: string;
  contactFirstName?: string;
  contactLastName?: string;
  phone?: string;
  cellphone?: string;
  email?: string;
  averageMonthlyBilling?: number | string | null;
}

interface IncompleteOnboardingSummaryProps {
  businessData: IncompleteOnboardingBusinessData;
  onDeleted?: () => void;
}

// Read-only "Información básica del comercio" + "Eliminar onboarding" card shown wherever a
// commerce with status "Sin completar" is found (e.g. SearchCommerce, MyOnboardings' view modal).
function IncompleteOnboardingSummary({ businessData, onDeleted }: IncompleteOnboardingSummaryProps) {
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

  const contactName = [businessData.contactFirstName, businessData.contactLastName].filter(Boolean).join(' ');

  const fieldValues = [
    businessData.rut,
    businessData.fantasyName,
    businessData.socialReason,
    contactName,
    businessData.phone,
    businessData.cellphone,
    businessData.email,
  ];

  return (
    <div className="confirmation incomplete-onboarding-summary">
      <InfoBlock
        title="Información básica del comercio"
        fields={updateBlockFields(incompleteBasicInfoFields, fieldValues)}
        borderNone
      />
      <Container className="d-flex justify-content-end buttons-container">
        <BorderlessButton
          buttonClass="defined-border"
          text="Eliminar onboarding"
          icon={DeleteIconSecondary}
          onClick={() => setShowDeleteModal(true)}
        />
      </Container>
      <DeleteOnboardingModal
        show={showDeleteModal}
        businessId={businessData.id ? +businessData.id : null}
        onCancel={() => setShowDeleteModal(false)}
        onDeleted={() => {
          setShowDeleteModal(false);
          onDeleted?.();
        }}
      />
    </div>
  );
}

export default IncompleteOnboardingSummary;
